module.exports = __webpack_public_path__ + "static/bobby-mcdonald-8baffdfd04d12030b75e36afd75efb1c.jpg";